<template>
    <v-container grid-list-xl fluid v-if="data && optionsDevices">
      <v-layout row>
      
      <v-flex xs2 align-end>
        <v-toolbar dark color="primary">
          <img v-bind:src="computeLogo" style="height: 36px !important;" alt="Logo">
        </v-toolbar>
        <date-picker 
          range
          placeholder="Select a date range"
          confirm
          v-model = "date"
          style = "width:100%"
          @confirm = "updateMarkers()"
          class="mb-3 mt-3"
          @clear = "clearDatepicker()"
        >
        </date-picker>
        <treeselect
          :multiple="true"
          :options="optionsDevices"
          placeholder="Select your device(s) OR Groups"
          v-model="valuesDevices"
          @input="getData()"
        />
          <v-flex lg12 sm12 xs12>
            <mini-statistic icon="supervisor_account" :title="''+total_responses" :sub-title="'Responses'" color="indigo lighten-4">
            </mini-statistic>
          </v-flex> 
          <v-flex lg12 sm12 xs12>
            <mini-statistic icon="devices" :title="''+total_devices" :sub-title="'Devices'" color="blue lighten-4">
            </mini-statistic>
          </v-flex>
      </v-flex>
      
      <v-flex xs10>
        <GmapMap
          :center="{lat:-12.10137, lng:-77.00781}"
          :zoom="11"
          style="width: 100%; height: 80vh"
        >
        <gmap-info-window :options="map.infoOptions" :position="map.infoWindowPos" :opened="map.infoWinOpen" @closeclick="map.infoWinOpen=false">
          <strong style="text-align:center">Response detail</strong><br>
          <div style="text-align:left">
            <b>Survey: </b>{{map.infoContent.survey}} <br>
            <b>Device: </b> {{map.infoContent.device}}<br>
            <b>Score: </b> {{map.infoContent.score}} <br>
            <b>Hour: </b> {{map.infoContent.hour}} <br>
            <b>Date: </b> {{map.infoContent.date_response}} <br>
            <b>Comment: </b> {{map.infoContent.comment}} <br>
            <b>Address: </b> {{map.infoContent.address}} <br>
          </div>
        </gmap-info-window>
          <GmapMarker
            :key="index" v-for="(m, index) in renderedMarkers" @click="toggleInfoWindow(m,index)"
            :icon="m.image"
            :position="m.position"
            :clickable="true"
            :draggable="false"
          />
        </GmapMap>
      </v-flex>
    </v-layout>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Treeselect from '@riophae/vue-treeselect';
// import the styles treeselect
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';

export default {
  components: {
    DatePicker,
    Treeselect,
    MiniStatistic
  },
  data () {
    return {
      steps: 1,
      optionsDevices: [],
      valuesDevices: [],
      title: '',
      type: 'custom',
      data: null,
      start_date: 'empty',
      end_date: 'empty',
      map: {
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        center: {
          lat: -12.10137,
          lng: -77.00781
        },
        infoWindowPos: null,
        currentMidx: null,
        infoWinOpen: false,
        infoContent: '',
      },
      date: null,
      total_devices: 0,
      total_responses: 0,
    };
  },
  computed: {
    renderedMarkers: function () {
      let _self = this;
      let markers = [];
      this.data.forEach(function (e) {
        markers.push(_self.formatMarker(e));
      });
      return markers;
    },
    computeLogo () {
      return process.env.LOGO_WHITE_PATH;
    },
  },
  mounted () {
    this.getData();
    this.getTreeSelect();
  },
  methods: {
    getData () {
      let devices = this.valuesDevices.length > 0 ? this.valuesDevices : 'empty';
      let url = 'devices/geolocation/' + this.$route.params.survey_id + '/' + this.start_date + '/' + this.end_date + '/' + devices;
      let self = this;
      window.axios.get(url).then(response => {
        self.data = response.data.responses;
        self.total_responses = response.data.total_responses;
        self.total_devices = response.data.total_devices;
      });
    },
    getTreeSelect () {
      window.axios.get('devices/geolocation/tree-devices/' + this.$route.params.survey_id).then(response => {
        this.optionsDevices = response.data.tree_select_devices;
      });
    },
    formatMarker: function (e) {
      return {
        position: {
          lat: e.lat,
          lng: e.lng
        },
        infoText: {
          device: e.device.name,
          survey: e.round,
          score: e.value,
          hour: e.hour,
          date_response: e.date_response,
          address: e.address
        },
        image: null,
      };
    },
    toggleInfoWindow: function (marker, idx) {
      this.map.infoWindowPos = marker.position;
      this.map.infoContent = marker.infoText;
      // check if its the same marker that was selected if yes toggle
      if (this.map.currentMidx === idx) {
        this.map.infoWinOpen = !this.map.infoWinOpen;
      }
      // if different marker set infowindow to open and reset current marker index
      else {
        this.map.infoWinOpen = true;
        this.map.currentMidx = idx;
      }
    },
    updateMarkers: function () {
      this.start_date = this.formatDate(this.date[0]);
      this.end_date = this.formatDate(this.date[1]);
      this.getData();
    },
    formatDate: function (d) {
      let datestring = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
      return datestring;
    },
    clearDatepicker: function () {
      this.start_date = 'empty';
      this.end_date = 'empty';
      this.getData();
    }
  }
};
</script>
<style>
.footer-stats {
    transform: translateY(-100%);
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/client/map/Map.vue